import { Box, Container, Typography, Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import image from "../../assets/images/AboutCta.png"
import Animator from "../Aminator/Animator"
import { Link } from "react-router-dom"


export default function CTASection() {
    const { t } = useTranslation();
    return (
        <Box className="py-5 md:py-10 bg-[#FCFCFC] relative px-2 md:px-16 overflow-hidden">
            <Container maxWidth="xl">
                <Box className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Column - Content */}
                    <Animator variant="fade" timeout={800} delay={300}>
                        <Box className="lg:pr-8 order-2 md:order-1">
                            <Animator variant="fade" timeout={800} delay={300}>
                                <Typography
                                    variant="h3"
                                    className="text-black "
                                    sx={{
                                        fontSize: { xs: "24px", md: "2.25rem" },
                                        fontFamily: "'Montserrat', sans-serif",
                                        fontWeight: 600,
                                        marginBottom: "24px",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    {t("about.cta.title")}
                                </Typography>
                            </Animator>
                            <Animator variant="fade" timeout={800} delay={400}>
                                <Typography
                                    variant="body1"
                                    className="text-[#00000080] mb-8"
                                    sx={{
                                        fontSize: { xs: "16px", md: "20px" },
                                        lineHeight: 1.5,
                                        marginBottom: "20px",
                                        fontFamily: "'Montserrat', sans-serif",
                                        fontWeight: 500,
                                    }}
                                >
                                    {t("about.cta.text")}
                                </Typography>
                            </Animator>
                            <Animator variant="fade" timeout={800} delay={600}>
                                <Link to={'/courses/categories'}>
                                    <Button
                                        variant="contained"
                                        className="bg-orange-500 hover:bg-orange-600 text-white font-medium normal-case px-6 py-3 rounded shadow-none"
                                        disableElevation
                                        sx={{
                                            fontSize: "1rem",
                                            fontWeight: 500,
                                            textTransform: "none",
                                            borderRadius: "6px",
                                            paddingX: "24px",
                                            paddingY: "12px",
                                            backgroundColor: "#FF5722",
                                            "&:hover": {
                                                backgroundColor: "#FF5722",
                                            },
                                        }}
                                    >
                                        {t("about.cta.viewAllCourses")}
                                    </Button>
                                </Link>
                            </Animator>
                        </Box>
                    </Animator>

                    {/* Right Column - Gradient Image */}
                    <Animator variant="slide" direction="left" timeout={800} delay={300}>
                        <Box className="relative order-1 md:order-2">
                            <Box
                                className="rounded-2xl overflow-hidden h-[419px] relative"

                            >
                                <img
                                    src={image}
                                    alt="Person silhouette against gradient background"
                                    className="w-full h-full object-cover"
                                />


                            </Box>
                        </Box>
                    </Animator>
                </Box>
            </Container>
        </Box>
    )
}
